export enum NotificationType {
    Audio = 'AUDIO',
    Video = 'VIDEO',
    Blog = 'BLOG',
    Event = 'EVENT'
}
